import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsForwardFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.72 11.96L12.56 18.96V13L3.7 18.96V4.96L12.56 10.92V4.96L22.72 11.96Z" />
    </SvgIcon>
  );
});
